import React, { Component, Fragment } from 'react';
import paymaya from 'paymaya-js-sdk';
import { convertTwoDecimalPoint, groupBy } from '../../../../server/util';
import { postWithHeadersResponse } from '../../../../server/actions';
import { ENV, URL_VERSION3 } from '../../../../server/constants';
class PayMaya extends Component {
    constructor(props){
        super(props);
        this.state={
            paymentToken:'',
            progress:false,
            requestReferenceNumber: "",
            items: [
                {
                    name: "",
                    quantity: 1,
                    totalAmount: {
                        value: '0'
                    }
                }
    
            ],
            buyer: {
                 "firstName": "",
                "middleName": "",
                "lastName": "",
                "contact": {
                  "phone": "",
                  "email": ""
                }
              },
            totalAmount: {
                value: '',
                currency: '',
            },
            metadata: {},
            redirectUrl: {
                success: "http://localhost:3000/success",
                failure: "http://localhost:3000/failure",
                cancel: "http://localhost:3000/cancel"
            },
            bodyResponse: {},
            errorResponse: {}
        }
    }
    postOrderRequest=()=>{
        const {studentData, mealType, postDataForPayMaya}=this.props;
        const mealObject=postDataForPayMaya(); 
        const reqObject={
            studentId:mealObject.studentId,
            paymentType: "Online",
            calIdWCountByMonth:mealObject.calIdWCountByMonth,
            instantPayAmt: mealObject.instantPayAmt,
            transactionFees: mealObject.transactionFees,
            appFeeAmount: mealObject.appFeeAmount,
            //donationAmt: 15,
            //donationNoOfMeals: "3",
            walletAmt: mealObject.walletAmt
        };
        let headers = {
            'Content-Type': 'application/json'
        };
        return postWithHeadersResponse(`${URL_VERSION3}/orderMenu/${mealType}?studentRecId=${reqObject.studentId}&access_token=`, JSON.stringify(reqObject),
        headers);
    }
    addLunchBalRequest=()=>{
        const {postDataForPayMaya}=this.props;
        const mealObject=postDataForPayMaya(); 
        let headers = {
            'Content-Type': 'application/json'
        };
        return postWithHeadersResponse("/transactions/depositAmtThruOnline?access_token=", JSON.stringify(mealObject),headers);        
    }
    handleCheckout=()=>{
        const {formValues, userInfo, paymentObj,postDataForPayMaya, paymentDesc, studentData}=this.props;
        const { requestReferenceNumber, totalAmount, items, metadata, redirectUrl, buyer } = this.state;
        const mealObject=postDataForPayMaya(); 
        this.setState({
            progress: true,
            errorResponse: {}
        });
        if(paymentDesc==='LUNCH_BAL'){
            this.addLunchBalRequest().then(response=>{
                if (response.statusCode!==200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 200) {
                    const bodyResponseForCheckout = {
                        requestReferenceNumber:res.token,
                        totalAmount: {
                            value: parseFloat(convertTwoDecimalPoint(mealObject.totalTransactionAmount,2))+parseFloat(convertTwoDecimalPoint(mealObject.appFeeAmount,2))+parseFloat(convertTwoDecimalPoint(mealObject.transactionFees,2)),
                            currency: 'PHP',
                        },
                        items:((mealObject||{}).studentWiseTransactions||[]).map(std=>{
                            return {
                                name: std.studentRecId,
                                quantity: 1,
                                totalAmount: {
                                    value: parseFloat(convertTwoDecimalPoint(std.transactionAmount,2))
                                }
                            }
                        }),
                        buyer:{
                            firstName: userInfo.parent,
                            middleName: userInfo.parent,
                            lastName: userInfo.parent,
                            contact: {
                                phone: "+639181008888",
                                email: userInfo.parent,
                              }
                        },
                        metadata,
                        redirectUrl: {
                            success: `${window.location.origin}/parent/paymayaCallback/success`,
                            failure: `${window.location.origin}/parent/paymayaCallback/failure`,
                            cancel: `${window.location.origin}/parent/paymayaCallback/cancel`
                        },
                        
                    };
                    this.setState({
                        progress: true,
                        errorResponse: {}
                    });        
                    const groupByFormValues=groupBy(formValues||[],'name')||{};        
                    paymaya.init(((groupByFormValues.publicKey||[])[0]||{}).value||'', (ENV=='Production'?false: true));
                    paymaya.createCheckout(bodyResponseForCheckout).then().catch(err => {
                        this.setState({
                            errorResponse: err,
                            progress: false
                        })
                    });                    
                }
            }).catch(
                (error) => {
                    this.setState({progress: false});
                   // _addNotificationError(error.message, this)
                   alert(error.message);
                    console.log('Meal order Creation Error', error)
                }
            );
        }else if(paymentDesc==='ORDER_PAY'){
            this.postOrderRequest()
            .then(response=>{
                if (response.statusCode!==200) {
                    throw Error(response.statusMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 200) {
                    const bodyResponseForCheckout = {
                        requestReferenceNumber:res.token,
                        totalAmount: {
                            value:convertTwoDecimalPoint(parseFloat(convertTwoDecimalPoint(mealObject.instantPayAmt,2))+parseFloat(convertTwoDecimalPoint(mealObject.transactionFees,2))+parseFloat(convertTwoDecimalPoint(mealObject.appFeeAmount,2)),2) ,
                            currency: 'PHP',
                        },
                        items:[
                            {
                                name:`${studentData.lastName} ${studentData.firstName}`,
                                quantity: 1,
                                totalAmount: {
                                    value:convertTwoDecimalPoint(parseFloat(convertTwoDecimalPoint(mealObject.instantPayAmt,2))+parseFloat(convertTwoDecimalPoint(mealObject.transactionFees,2))+parseFloat(convertTwoDecimalPoint(mealObject.appFeeAmount,2)),2) ,
                                }
                            }
                        ],
                        buyer:{
                            firstName: userInfo.parent,
                            middleName: userInfo.parent,
                            lastName: userInfo.parent,
                            contact: {
                                phone: "+639181008888",
                                email: userInfo.parent,
                              }
                        },
                        metadata,
                        redirectUrl: {
                            success: `${window.location.origin}/parent/paymayaCallback/success`,
                            failure: `${window.location.origin}/parent/paymayaCallback/failure`,
                            cancel: `${window.location.origin}/parent/paymayaCallback/cancel`
                        },
                        
                    };
                    this.setState({
                        progress: true,
                        errorResponse: {}
                    });        
                    const groupByFormValues=groupBy(formValues||[],'name')||{};        
                    paymaya.init(((groupByFormValues.publicKey||[])[0]||{}).value||'', (ENV=='Production'?false: true));
                    paymaya.createCheckout(bodyResponseForCheckout).then().catch(err => {
                        this.setState({
                            errorResponse: err,
                            progress: false
                        })
                    });                    
                }
                }).catch(
                    (error) => {
                        this.setState({progress: false});
                    // _addNotificationError(error.message, this)
                    alert(error.message);
                        console.log('Meal order Creation Error', error)
                    }
                );

            }
        }
    validateSchoolName=(school='')=>{
        const schoolsArray=[{name:'Institute of Culinary Management - British School Manila', shortName:'ICM - British School Manila'}];
        const schoolFindObj=schoolsArray.find(s=>{
            return s.name==school
        });
        if(schoolFindObj){
            return schoolFindObj.shortName
        }else{
            if(school.length>50){
                return school.substring(0, 50);
            }else{
                return school
            }
        }
    }
    render() {
        return (
            <Fragment>
               <button type='button' className="btn btn-sm btn-success" style={{margin:'0px 0px 0px 5px'}} disabled={this.state.progress} 
               onClick={this.handleCheckout}><i className="glyphicon glyphicon-ok"></i> Pay With Card</button>                
            </Fragment>
        );
    }
}

export default PayMaya;


// WEBPACK FOOTER //
// ./src/components/Misc/PaymentModule/paymaya/index.js